import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import OneClickPath from '../assets/images/one_click_path.svg';
import Link from '../assets/images/link.svg';
import InstantLiquidity from '../assets/images/instant_liquidity.svg';

const TokenFactory: React.FC = () => {
  const handleRequestAccess = () => {
    window.open('https://loopchain.io/token-factory/#Contact', '_blank');
  };

  const features = [
    {
      icon: OneClickPath,
      title: 'One-Click Launch',
      description: 'Deploy in seconds with our simplified interface',
      iconBg: 'bg-[#2777EF]',
    },
    {
      icon: Link,
      title: 'Asset-Backed',
      description: 'Link tokens to real business value (miles, points, credits)',
      iconBg: 'bg-transparent',
      iconColor: 'text-[#2777EF]',
    },
    {
      icon: InstantLiquidity,
      title: 'Instant Liquidity',
      description: 'Trade immediately on Solana DEX',
      iconBg: 'bg-transparent',
      iconColor: 'text-[#2777EF]',
    },
  ];

  return (
    <div className="min-h-[calc(100vh-8rem)] flex flex-col">
      {/* Header */}
      <div className="mb-6 sm:mb-8">
        <h1 className="text-xl sm:text-2xl font-semibold text-white">Features</h1>
      </div>

      {/* Features Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 mb-8 sm:mb-12">
        {features.map((feature, index) => (
          <div
            key={index}
            className="bg-[#182233] border border-gray-600/50 rounded-xl p-5 sm:p-6 hover:border-[#2777EF]/30 transition-all duration-300"
          >
            {/* Icon */}
            <div className="mb-4">
              <div
                className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center ${
                  feature.iconBg
                }`}
              >
                <img
                  src={feature.icon}
                  alt={feature.title}
                  className={`w-56 h-56`}
                />
              </div>
            </div>

            {/* Title */}
            <h3 className="text-lg sm:text-xl font-semibold text-white mb-2">
              {feature.title}
            </h3>

            {/* Description */}
            <p className="text-sm sm:text-base text-gray-400 leading-relaxed">
              {feature.description}
            </p>
          </div>
        ))}
      </div>

      {/* CTA Button */}
      <div className="mt-auto">
        <button
          onClick={handleRequestAccess}
          className="w-full bg-[#2777EF] hover:bg-[#1e5fc7] text-white font-medium py-4 sm:py-5 px-6 rounded-full flex items-center justify-center gap-2 transition-all duration-300 text-sm sm:text-base"
        >
          Request Token Factory Access
          <ArrowUpRight className="w-4 h-4 sm:w-5 sm:h-5" />
        </button>
      </div>

      {/* Footer */}
      <div className="mt-8 sm:mt-12 text-center">
        <p className="text-gray-500 text-sm">© 2025 LoopChain</p>
      </div>
    </div>
  );
};

export default TokenFactory;

